import * as types from './constants';

// Batch Message Composer
export const openBatchMessageComposer = data => (
  { type: types.OPEN_BATCH_MESSAGE_COMPOSER, payload: data }
);

export const closeBatchMessageComposer = data => (
  { type: types.CLOSE_BATCH_MESSAGE_COMPOSER, payload: data }
);

export const setBatchMessageComposerMessage = data => (
  { type: types.SET_BATCH_MESSAGE_COMPOSER_MESSAGE, payload: data }
);

// Batch Message Report
export const openBatchMessageReport = data => (
  { type: types.OPEN_BATCH_MESSAGE_REPORT, payload: data }
);

export const closeBatchMessageReport = data => (
  { type: types.CLOSE_BATCH_MESSAGE_REPORT, payload: data }
);

// Batch Message Status
export const addBatchMessageStatus = data => (
  { type: types.ADD_BATCH_MESSAGE_STATUS, payload: data }
);

export const updateBatchMessageStatus = data => (
  { type: types.UPDATE_BATCH_MESSAGE_STATUS, payload: data }
);

export const removeBatchMessageStatus = data => (
  { type: types.REMOVE_BATCH_MESSAGE_STATUS, payload: data }
);

// Batch Message Template
export const openBatchMessageTemplate = data => (
  { type: types.OPEN_BATCH_MESSAGE_TEMPLATE, payload: data }
);

export const setBatchMessageTemplate = data => (
  { type: types.SET_BATCH_MESSAGE_TEMPLATE, payload: data }
);

export const closeBatchMessageTemplate = () => (
  { type: types.CLOSE_BATCH_MESSAGE_TEMPLATE }
);